import { EntityBase } from './EntityBase';
import { Material } from './Material';
import { TypePrecautionStatement } from './TypePrecautionStatement';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class MaterialPrecautionCode extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   materialPrecautionCodeId: number;
   materialId: number;
   typePrecautionStatementId: string;
   pCount: number;
   aCount: number;
   deleteNextLM: boolean;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   material: Material;
   typePrecautionStatement: TypePrecautionStatement;
}

